// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"acc41524","53":"c409e9ec","313":"65386ea7","349":"c409e9ec","890":"60ea205c"}[chunkId] + ".chunk.css";
};